module.exports = __webpack_public_path__ + "static/media/downedbranches-icon.049e88c2.svg";